<template>
  <path
    d="M17 3.00018H7C5.9 3.00018 5 3.90018 5 5.00018V21.0002L12 18.0002L19 21.0002V5.00018C19 3.90018 18.1 3.00018 17 3.00018Z"
  />
</template>
